import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { fetchUrgentContacts, updateContactTimestamp } from '../../lib/fetch/contacts';
import { useAuth } from '../../components/Auth';
import ContactItem from './ContactItem';
import './ContactsModalUrgent.scss';

const ContactsModalUrgent = ({ shouldShow = true }) => {
  const [t] = useTranslation('COMMON');
  const [contacts = [], setContacts] = useState([]);
  const [{ token, isAuthenticated } = {}] = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      fetch(token)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const fetch = async (token) => {
    const { error, data } = await fetchUrgentContacts({ token });

    if (error) {
      setContacts([]);
      return;
    }
    setContacts(data);
  };

  const dismiss = (id) => {
    const data = (contacts || []).filter((contact) => contact.id !== id);
    setContacts(data);
  };

  const markAsUpdated = async (id) => {
    const { error } = await updateContactTimestamp({ token, id });

    if (error) {
      return;
    }
    dismiss(id);
  };

  return (
    <>
      <Modal
        isOpen={shouldShow && contacts && contacts.length > 0}
        backdrop="static"
        keyboard={false}
        centered={false}
        zIndex="10000"
        scrollable={true}
        fade={false}
        className="custom-modal-padding"
      >
        <ModalHeader>
          {t(`COMMON:CHECK_URGENT_CONTACTS`)}
        </ModalHeader>
        <ModalBody>
          {
            contacts.map((contact, key) => (
              <ContactItem
                markAsUpdated={markAsUpdated}
                dismiss={dismiss}
                contact={contact}
                key={key}
              />
            ))
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default ContactsModalUrgent;
